export default __webpack_public_path__ + "static/media/P940_CoC.0a1b6737.pdf";